(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ActivityHistoryDialogController', ActivityHistoryDialogController);

    ActivityHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ActivityHistory', 'Contract', 'Shipment', 'Invoice', 'Lot'];

    function ActivityHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ActivityHistory, Contract, Shipment, Invoice, Lot) {
        var vm = this;

        vm.activityHistory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.contracts = Contract.query();
        vm.shipments = Shipment.query();
        vm.invoices = Invoice.query();
        vm.lots = Lot.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.activityHistory.id !== null) {
                ActivityHistory.update(vm.activityHistory, onSaveSuccess, onSaveError);
            } else {
                ActivityHistory.save(vm.activityHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:activityHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.actDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
